// src/components/AddBookModal.jsx
import React, { useState } from "react";
import "./AddBookModal.css";

const AddBookModal = ({ onClose, onCreate }) => {
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    onCreate({ name });
  };

  return (
    <div className="abm-backdrop" onClick={onClose}>
      <div
        className="abm-sheet"
        onClick={(e) => e.stopPropagation()} // prevents closing when clicking inside
      >
        {/* HEADER */}
        <div className="abm-header">
          <i className="bi bi-journal-plus abm-header-icon"></i>
          <h3>Create New Book</h3>
        </div>

        {/* FORM */}
        <form onSubmit={handleSubmit} className="abm-body">
          <label className="form-label">
            Book Name
            <input
              className="form-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Office Cash 2025"
            />
          </label>

          {/* ACTIONS */}
          <div className="abm-actions">
            <button type="button" className="abm-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="abm-create">
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBookModal;
